import React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { get, debounce } from 'lodash';
import { Link, withRouter } from 'react-router-dom';
import { Form, Scope } from 'informed';
import FormContainer from '../../containers/Form';
import FiltroAvancadoItens from './FiltroAvancadoItens';
import { API_HOST } from '../../consts';
import Item from '../../components/Item';
import StatusRibbon from '../../components/StatusRibbon';
import InputText from '../../components/inputs/InputText';
import Loading from '../../components/Loading';
import ContainerItemComentarios from '../../components/ContainerItemComentario';
import { getErrorToast } from '../../utils';
import { ItemStyleButton } from './styles';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class Itens extends React.Component {
  state = {
    itens: [],
    checked: [],
    OpenModal: false,
    isComentariosOpen: false,
    highlightItemId: null
  };

  componentDidMount() {
    this.fetchData();
    this.fetchMe();
    this.fetchAvaliacao();
    this.getAvaliationPPI();
  }

  toggleModal = (name) => {
    const { openModal } = this.state;
    this.setState({ openModal: openModal === name ? null : name });
  };

  fetchMe() {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((response) => {
        this.setState({ me: response.data });
      })
      .catch((response) => console.log(response.error));
  }

  fetchAvaliacao() {
    axios
      .get(`${API_HOST}/avaliacoes/avaliacao/${this.props.match.params.id}`)
      .then((response) => {
        this.setState({ isPublic: response.data.publico });
        this.setState({ title: response.data.nome });
      })
      .catch(() => {});
  }

  fetchMe(item) {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((response) => {
        let groups = response.data.logged_group.map((f) => {
          return f.toUpperCase();
        });
        this.setState({
          isDisabled:
            groups.includes('ADMINISTRADOR') || groups.includes('DRE')
              ? false
              : item && response.data.id == item.criado_por_id
              ? false
              : true,
          me: response.data
        });
      })
      .catch((response) => console.log(response.error));
  }

  fetchData(loading = true) {
    const { match } = this.props;

    if (loading) {
      this.setState({ fetchingData: true });
    }

    return axios
      .get(`${API_HOST}/avaliacoes/avaliacao_item`, {
        params: {
          avaliacao: match.params.id
        }
      })
      .then((response) => {
        const itens = response.data.results || response.data;

        this.setState({
          checked: itens.map((item) => get(item, 'item.id')),
          fetchingData: false,
          criado_por:
            response.data.length > 0
              ? response.data[0].avaliacao.criado_por
              : 'none'
        });

        this.formApi.setValues({
          itens
        });
      });
  }

  handleResultClick = (event, data) => {
    const { checked } = event.target;
    if (checked) {
      axios
        .post(`${API_HOST}/avaliacoes/avaliacao_item`, data)
        .then(() => {
          this.fetchData(false);
        })
        .catch((error) => {
          toast.error(getErrorToast(error));
        });
    } else {
      const { itens } = this.formApi.getState().values;
      const item = itens.find((i) => get(i, 'item.id') === data.item);
      this.removeItem(item);
    }
  };

  handleAddAll = (itemFilters) => {
    const { match } = this.props;
    axios
      .post(`${API_HOST}/avaliacoes/bulk_avaliacao_item`, {
        avaliacao: match.params.id,
        itens: itemFilters
      })
      .then(() => {
        this.fetchData(false).then(() => {
          this.distribuirValor();
        });
        this.toggleModal(null);
      });
  };

  handleChange = (index, id, data) => {
    this.patchItem(index, id, data);
  };

  patchItem = debounce((index, id, data) => {
    axios
      .patch(`${API_HOST}/avaliacoes/avaliacao_item/${id}`, data)
      .then(() => {})
      .catch((error) => {
        const status = get(error, 'response.status');
        if (status === 400) {
          const errors = get(error, 'response.data');
          Object.keys(errors).forEach((field) => {
            const fieldName = `itens[${index}].${field}`;
            if (this.formApi.fieldExists(fieldName)) {
              this.formApi.setError(fieldName, errors[field]);
            }
          });
        }
      });
  }, 500);

  removeItem(item) {
    this.setState({ editing: true });

    axios
      .delete(`${API_HOST}/avaliacoes/avaliacao_item/${item.id}`)
      .then(() => {
        this.fetchData(false).then(() => {
          this.setState({ editing: false });
          this.distribuirValor();
        });
      })
      .catch(() => {
        this.setState({ editing: false });
      });
  }

  alterarPosicao = (item, offset) => {
    this.setState({ editing: true });

    axios
      .patch(`${API_HOST}/avaliacoes/avaliacao_item/${item.id}`, {
        posicao: item.posicao + offset
      })
      .then(() => {
        this.fetchData(false).then(() => {
          this.setState({ editing: false });
        });
      });
  };

  distribuirValor = () => {
    this.setState({ distribuindoValor: true });

    const { match } = this.props;
    axios
      .get(
        `${API_HOST}/avaliacoes/avaliacao/${match.params.id}/distribuir_valor`
      )
      .then((response) => {
        const { itens } = this.formApi.getState().values;
        const { valor } = response.data;

        this.formApi.setValues({
          itens: itens.map((item) => ({ ...item, valor }))
        });
      })
      .catch((error) => {
        const status = get(error, 'response.status');
        if (status === 400) {
          const msg = get(error, 'response.data.valor[0]');
          if (msg) {
            toast.error(msg);
            return;
          }
        }

        if (status !== 403) {
          toast.error('Ocorreu um erro desconhecido.');
        }
      })
      .then(() => this.setState({ distribuindoValor: false }));
  };

  renderItens(formState) {
    const {
      fetchingData,
      editing,
      openModal,
      criado_por,
      me,
      isComentariosOpen,
      highlightItemId
    } = this.state;
    const { isDisabled, hasPermission, hasPermissionAll } = this.props;
    // disabled={editing ? true : me && criado_por !== me.last_name}

    if (fetchingData) {
      return <Loading />;
    }

    if (openModal) {
      return null;
    }

    const itens = get(formState, 'values.itens') || [];
    return itens.map((item, index) => (
      <div>
        {index === 0 && (
          <div className="d-flex justify-content-end mb-2">
            <button
              className="btn"
              onClick={() =>
                this.setState({ isComentariosOpen: !isComentariosOpen })
              }
              aria-label={isComentariosOpen ? 'Ocultar comentários' : 'Mostrar comentários'}
              style={{
                borderRadius: '24px',
                padding: '6px 14px',
                border: '1px solid #6A35DD',
                color: isComentariosOpen ? '#fff' : '#6A35DD',
                backgroundColor: isComentariosOpen ? '#6A35DD' : '#fff',
                boxShadow: '0 1px 2px rgba(0,0,0,0.06)'
              }}
            >
              <i
                className={isComentariosOpen ? 'fas fa-eye-slash' : 'fas fa-eye'}
                style={{ marginRight: 8 }}
              />
              {isComentariosOpen ? 'Ocultar comentários' : 'Mostrar comentários'}
            </button>
          </div>
        )}
        <div
          className="d-flex"
          style={{ gap: isComentariosOpen ? '8px' : 0, alignItems: 'flex-start' }}
        >
          <div
            className="card item-card"
            key={item.id}
            style={{
              width: isComentariosOpen ? '70%' : '100%',
              marginBottom: '16px',
              transition: 'width 0.3s'
            }}
          >
            <div className="card-header">
              <div className="row">
                <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 mb-2">
                  <strong>{item.posicao}.</strong> Objeto {get(item, 'item.id')}
                </div>
                <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 mb-2">
                  <StatusRibbon color={get(item, 'item.status.cor')}>
                    {get(item, 'item.status.descricao')}
                  </StatusRibbon>
                  <div
                    role="group"
                    className="btn-group list-btn pull-right mt-2"
                  >
                    {index !== formState.values.itens.length - 1 && (
                      <button
                        className="btn btn-white"
                        onClick={() => this.alterarPosicao(item, 1)}
                        disabled={editing ? true : isDisabled}
                      >
                        <i className="fas fa-arrow-down" />
                      </button>
                    )}
                    {index > 0 && (
                      <button
                        className="btn btn-white"
                        onClick={() => this.alterarPosicao(item, -1)}
                        disabled={editing ? true : isDisabled}
                      >
                        <i className="fas fa-arrow-up" />
                      </button>
                    )}
                    <button
                      className="btn btn-white"
                      onClick={() => this.removeItem(item)}
                      disabled={editing ? true : isDisabled}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <Scope scope={`itens[${index}]`}>
                  <InputText
                    field="valor"
                    label="Valor"
                    col="col-md-3"
                    onChange={(value) =>
                      this.handleChange(index, item.id, { valor: value })
                    }
                    disabled={isDisabled}
                  />

                  {/* <InputText
                field="posicao_atual"
                label="Posição Atual do Item"
                col="col-md-3"
                onChange={(value) =>
                  this.handleChange(index, item.id, { posicao_atual: value })
                }
                disabled={isDisabled}
              /> */}
                </Scope>
              </div>
            </div>
            <div className="card-body ">
              <Item item={item.item} avaliacaoItem={item} enableHighlight={highlightItemId === item.id} api={this.formApi} />
            </div>
          </div>
          {isComentariosOpen && (
           <ContainerItemComentarios
              item={item}
              api={this.formApi}
              // enableHighlight: true only for the item that matches highlightItemId
              enableHighlight={highlightItemId === item.id}
              // toggle highlight for this specific item (ignore incoming boolean)
              setEnableHighlight={() => this.setState((prev) => ({ highlightItemId: prev.highlightItemId === item.id ? null : item.id }))}
            />
          )}
        </div>
      </div>
    ));
  }

  validateInstrumento = (goto) => {
    const { match, history } = this.props;

    if (goto === 'dados') {
      history.push(goto);
      return;
    }

    return axios
      .post(`${API_HOST}/avaliacoes/avaliacao/${match.params.id}/validate`)
      .then((response) => {
        history.push(goto);
      })
      .catch((error) => {
        const status = get(error, 'response.status');

        if (status === 400) {
          const msg = get(error, 'response.data.non_field_errors.0');
          if (msg) {
            toast.error(msg);
            return;
          }
        }
      });
  };

  getAvaliationPPI = () => {
    if (
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.id
    ) {
      axios
        .get(
          `${API_HOST}/avaliacoes/avaliacao?id=${this.props.match.params.id}`
        )
        .then((response) => {
          if (response.data.results[0].nome.includes('PPI')) {
            if (response.data.results[0].itens === 0) {
              this.setState({ OpenModal: true });
            }
          }
        })
        .catch((error) => {
          console.error('Erro na requisição:', error);
        });
    } else {
      console.error(
        "Propriedade 'id' não encontrada em this.props.match.params"
      );
    }
  };

  handleState = () => {
    this.setState({ OpenModal: false });
  };

  render() {
    const { openModal, checked, distribuindoValor, me } = this.state;
    const { isDisabled, hasPermission, hasPermissionAll } = this.props;
    const groups =
      me &&
      me.logged_group.map((f) => {
        return f.toUpperCase();
      });

    const urlAtual = window.location.href;
    const idAvaliacao = urlAtual
      .split('/instrumentos-cognitivos/')[1]
      .split('/')[0];

    return groups && groups.includes('REVISOR') ? (
      <FormContainer
        title="Adicionar Objetos de Aprendizagem"
        previous="dados"
        next="revisao"
        subtitle="Adicione Objetos de Aprendizagem do banco de objetos ou crie um novo objeto."
        onClick={(goto) => this.validateInstrumento(goto)}
        isExam={true}
      >
        <Form
          getApi={(formApi) => {
            this.formApi = formApi;
          }}
          initialValues={{ itens: [] }}
        >
          {({ formState }) => (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <ItemStyleButton>
                  <button
                    className="sc-AxiKw coUCbo btn mb-3 button-primary"
                    onClick={() => this.toggleModal('modalItens')}
                    disabled={isDisabled}
                    style={{
                      borderRadius: '70px',
                      padding: '5px 30px',
                      marginLeft: '0px'
                    }}
                  >
                    <i style={{ marginRight: '5px' }} className="fas fa-plus" />{' '}
                    Adicionar objetos
                  </button>
                </ItemStyleButton>

                {get(formState, 'values.itens.length') > 0 && (
                  <button
                    className="btn btn-sm mb-3 "
                    onClick={this.distribuirValor}
                    disabled={distribuindoValor ? true : isDisabled}
                    style={{
                      width: '50%',
                      textAlign: 'center',
                      borderRadius: '70px',
                      border: '1px solid #6A35DD',
                      color: '#6A35DD',
                      padding: '5px 30px'
                    }}
                  >
                    Distribuir valor dos objetos de aprendizagem
                  </button>
                )}
              </div>
              {this.renderItens(formState)}
            </>
          )}
        </Form>

        <FiltroAvancadoItens
          isPublic={this.state.isPublic}
          isOpen={openModal === 'modalItens'}
          toggle={() => {
            this.toggleModal('modalItens');
            this.distribuirValor();
          }}
          filter={false}
          onResultClick={this.handleResultClick}
          onAddAll={this.handleAddAll}
          checked={checked}
        />
      </FormContainer>
    ) : (
      <FormContainer
        title={`${this.state.title && this.state.title} - ${
          this.props.match.params.id
        } | Adicionar Objetos de Aprendizagem`}
        previous="dados"
        last="/instrumentos-cognitivos"
        subtitle="Adicione Objetos de Aprendizagem do banco de objetos ou crie um novo objeto."
        onClick={(goto) => this.validateInstrumento(goto)}
        isExam={true}
      >
        <Form
          getApi={(formApi) => {
            this.formApi = formApi;
          }}
          initialValues={{ itens: [] }}
        >
          {({ formState }) => (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <div style={{ display: 'flex', gap: '24px' }}>
                  <ItemStyleButton>
                    <button
                      className="sc-AxiKw coUCbo btn mb-3 button-primary"
                      onClick={() => this.toggleModal('modalItens')}
                      disabled={isDisabled}
                      style={{
                        borderRadius: '70px',
                        padding: '8px 15px 8px 15px',
                        marginLeft: '0px',
                        fontFamily: 'Public Sans',
                        fontSize: '16px',
                        fontWeight: 700,
                        lineHeight: '24px',
                        letterSpacing: '0em',
                        textAlign: 'center'
                      }}
                    >
                      <i
                        style={{ marginRight: '5px' }}
                        className="fas fa-plus"
                      />{' '}
                      Adicionar Objeto
                    </button>
                  </ItemStyleButton>
                  <ItemStyleButton>
                    <Link
                      className="sc-AxiKw coUCbo btn mb-3 button-primary"
                      onClick={() => this.toggleModal('modalItens')}
                      disabled={isDisabled}
                      style={{
                        borderRadius: '70px',
                        padding: '8px 15px 8px 15px',
                        marginLeft: '0px',
                        fontFamily: 'Public Sans',
                        fontSize: '16px',
                        fontWeight: 700,
                        lineHeight: '24px',
                        letterSpacing: '0em',
                        textAlign: 'center'
                      }}
                      to="/itens/new/dados/tipo/1"
                    >
                      <i
                        style={{ marginRight: '5px' }}
                        className="fas fa-plus"
                      />{' '}
                      Criar item
                    </Link>
                  </ItemStyleButton>
                  <ItemStyleButton>
                    <Link
                      className="sc-AxiKw coUCbo btn mb-3 button-primary"
                      disabled={isDisabled}
                      style={{
                        borderRadius: '70px',
                        padding: '8px 15px 8px 15px',
                        marginLeft: '0px',
                        fontFamily: 'Public Sans',
                        fontSize: '16px',
                        fontWeight: 700,
                        lineHeight: '24px',
                        letterSpacing: '0em',
                        textAlign: 'center'
                      }}
                      to={`/itens/${idAvaliacao}/dados?id=/tipo/2`}
                    >
                      <i
                        style={{ marginRight: '5px' }}
                        className="fas fa-plus"
                      />{' '}
                      Criar recurso
                    </Link>
                  </ItemStyleButton>
                </div>
                <Modal
                  isOpen={this.state.OpenModal}
                  style={{ marginTop: '30rem' }}
                >
                  <ModalBody style={{ padding: '24px', borderRadius: '20px' }}>
                    <p style={{ marginBottom: '16px' }}>
                      Não encontramos em nossa base de dados nenhuma
                      correspondência com os critérios selecionados.
                    </p>
                    <p>
                      Recomendamos que você utilize os botões "Adicionar
                      Objetos" para pesquisar em nossa base ou "Criar Objetos"
                      para adicionar novos.
                    </p>
                  </ModalBody>
                  <ModalFooter>
                    <ItemStyleButton>
                      <button
                        className="sc-AxiKw coUCbo btn mb-3 button-primary"
                        onClick={this.handleState}
                        style={{
                          borderRadius: '70px',
                          padding: '5px 30px',
                          marginLeft: '0px'
                        }}
                      >
                        Entendi
                      </button>
                    </ItemStyleButton>
                  </ModalFooter>
                </Modal>
                {get(formState, 'values.itens.length') > 0 && (
                  <button
                    className="btn btn-sm mb-3 "
                    onClick={this.distribuirValor}
                    disabled={distribuindoValor ? true : isDisabled}
                    style={{
                      width: '50%',
                      textAlign: 'center',
                      borderRadius: '70px',
                      border: '1px solid #6A35DD',
                      color: '#6A35DD',
                      padding: '5px 30px',
                      backgroundColor: 'white'
                    }}
                  >
                    Distribuir valor dos objetos de aprendizagem
                  </button>
                )}
              </div>
              {this.renderItens(formState)}
            </>
          )}
        </Form>

        <FiltroAvancadoItens
          isPublic={this.state.isPublic}
          isOpen={openModal === 'modalItens'}
          toggle={() => {
            this.toggleModal('modalItens');
            this.distribuirValor();
          }}
          filter={false}
          onResultClick={this.handleResultClick}
          onAddAll={this.handleAddAll}
          checked={checked}
        />
      </FormContainer>
    );
  }
}

export default withRouter(Itens);
